const MAX_TOOLTIP_LENGTH = 200;
const truncateTooltip = (text, maxLength = MAX_TOOLTIP_LENGTH) => text.length > maxLength ? `${text.slice(0, maxLength).trimEnd()}…` : text;
export {
  MAX_TOOLTIP_LENGTH,
  truncateTooltip
};
